import { credentialsContent } from '@/mocks/homeData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CredentialsPanel() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section
      ref={ref}
      className="relative -mt-12 md:-mt-16 lg:-mt-24 z-20"
    >
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div
          className={`max-w-6xl mx-auto transition-all duration-800 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 rounded-2xl overflow-hidden bg-foreground-950/85 backdrop-blur-sm border-2 border-amber-500 shadow-2xl shadow-black/30">
            {credentialsContent.items.map((item, index) => (
              <div
                key={item.title}
                className={`relative flex flex-col items-center text-center p-5 md:p-7 transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                {index < credentialsContent.items.length - 1 && (
                  <div className="absolute right-0 top-1/4 bottom-1/4 w-px bg-foreground-600/50 hidden lg:block" />
                )}
                {index < credentialsContent.items.length - 2 && (
                  <div className="absolute bottom-0 left-1/4 right-1/4 h-px bg-foreground-600/50 lg:hidden" />
                )}

                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-500/10 border border-primary-500/20 mb-3 md:mb-4">
                  <i className={`${item.icon} text-primary-400 text-xl md:text-2xl`} />
                </div>

                <p className="text-sm md:text-base font-bold text-background-50 leading-snug whitespace-pre-line">
                  {item.title}
                </p>
                {item.subtitle && (
                  <p className="mt-1 text-xs md:text-sm text-foreground-400">
                    {item.subtitle}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}